var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19v-1.07a6.999 6.999 0 0 0 4.781-2.982C20.495 14.574 22 12.223 22 9V6a2 2 0 0 0-2-2h-1.268A2 2 0 0 0 17 3H7a2 2 0 0 0-1.732 1H4a2 2 0 0 0-2 2v3c0 3.223 1.505 5.574 4.219 5.948A6.999 6.999 0 0 0 11 17.929V19h-1a2 2 0 0 0-2 2h8a2 2 0 0 0-2-2h-1ZM4 6h1v5c0 .458.044.905.128 1.338C4.39 11.675 4 10.531 4 9V6Zm15 0v5c0 .458-.044.905-.128 1.338C19.61 11.675 20 10.531 20 9V6h-1ZM7 11V5h10v6a5 5 0 0 1-10 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyLarge);
export default __webpack_public_path__ + "static/media/trophy-large.75f575f6.svg";
export { ForwardRef as ReactComponent };